import React from 'react';

import PlanProfileTopHeader from './components/PlanProfileTopHeader';
import ChangePlanForm from './components/ChangePlanForm';

const PlanProfilePage: React.FC = () => {
  return (
    <>
      <PlanProfileTopHeader />
      <ChangePlanForm />
    </>
  )
}

export default PlanProfilePage;